import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import quartOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(quartOfYear);

export interface ProjectInspireTargetDetailDateSliceType {
  projectInspireTargetDetailDate: Date;
}
export const ProjectInspireTargetDetailSlice = createSlice({
  name: "ProjectInspireTargetDetailSlice",
  initialState: {
    projectInspireTargetDetailDate: new Date(),
  },
  reducers: {
    updateprojectInspireTargetDetailDate(state, action) {
      state.projectInspireTargetDetailDate = action.payload;
    },
  },
});

const { actions, reducer } = ProjectInspireTargetDetailSlice;
export const { updateprojectInspireTargetDetailDate } = actions;
export default reducer;
